// Mirrors functions/src/demoMode.ts's DEMO_MODE flag for the parts of the UI that need to know
// (a demo hint on the OTP screen, the demo-mode banner) -- the backend is the actual source of
// truth for what gets bypassed; this only controls what the UI shows about it.
export const isDemoMode = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
